import React from 'react';
import { PostsEditor } from '../editors/PostsEditor';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { PostFirst, PostFirstTypes, PostForm } from '../Post.types';
import { Icons } from '../../../../components/atoms/SVG';
import { ContentHeadline } from '../../ContentHeadline';
import { ButtonMinorAction } from '../../../../components/molecules/Btn/ButtonWrapper';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';

type PostReplyFormProps = {
  type: PostFirstTypes;
  post: PostFirst;
  setCurrentForm: (newState: PostForm | undefined) => void;
};

export function PostReplyForm({ type, post, setCurrentForm }: PostReplyFormProps) {
  const { t } = useSonTranslation('Posts');

  return (
    <div className="posts__post-reply">
      <div className="posts__interactions-close-reply">
        <ContentHeadline title={t(`default.heading.writeReply.${type}`)} hierarchy={4} />
        <ButtonMinorAction
          active
          icon={Icons.DECLINE_CROSS}
          text={t(`default.replyClose.${type}`)}
          href={`#reply-button-${post.id}`}
          onClick={() => setCurrentForm(undefined)}
          tooltipPlacement={TooltipPlacement.TOP}
        />
      </div>
      <div className="posts__reply-editor-container">
        <PostsEditor form={post.replyForm} type="reply" autoFocus uuid={post.id} />
      </div>
    </div>
  );
}
